import type { TeamFilter } from "@dashboardApi/apis/teamsData/types";

import type { FetchRequestError } from "@lib/errors";
import { FetchUserEncodedError } from "@lib/errors/FetchUserEncodedError";
import sharedConstants from "@lib/shared_constants";
import type { SHARED_CONSTANTS_TERRITORY_MANAGEMENT } from "@lib/shared_constants";

/**
 * Returned as a 4xx when save-path filter validation rejects a filter the new team would have
 * persisted, so the form can show the server's reason rather than a generic failure.
 */
export type TeamCreateInvalidFilterError = FetchUserEncodedError<
  SHARED_CONSTANTS_TERRITORY_MANAGEMENT["ERROR_CODES"]["INVALID_FILTER"]
>;

export const isTeamCreateInvalidFilterError = (error: FetchRequestError): error is TeamCreateInvalidFilterError => {
  return (
    error instanceof FetchUserEncodedError &&
    error.errorCode === sharedConstants.TERRITORY_MANAGEMENT.ERROR_CODES.INVALID_FILTER
  );
};

export interface TeamCreateResult {
  info: string;
  /** The id of the newly created team. Present on success; used to navigate to its detail view. */
  id?: string;
}

export interface PostAppsAppGroupIdTerritoryCreateProps {
  appGroupId: string;
  /**
   * The reachable-audience filters to persist on the new team. Omitted when `filters_unchanged`
   * is sent. A flat array of leaf filters (the same shape persisted on `TeamDescriptor.filters`).
   */
  filters?: TeamFilter[];
  /**
   * When true, the backend leaves filters untouched rather than re-deserializing a payload. Sent
   * by the team settings form when the audience filters were never edited, to limit blast radius.
   */
  filters_unchanged?: boolean;
  name: string;
}
